import script from "./NavAltButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavAltButton.vue?vue&type=script&setup=true&lang=ts"

import "./NavAltButton.vue?vue&type=style&index=0&id=499615ec&lang=css"

const __exports__ = script;

export default __exports__